import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=4f913234&scoped=true&"
import script from "./OffersView.vue?vue&type=script&lang=js&"
export * from "./OffersView.vue?vue&type=script&lang=js&"
import style0 from "./OffersView.vue?vue&type=style&index=0&id=4f913234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f913234",
  null
  
)

/* custom blocks */
import block0 from "./OffersView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports